<template>
  <div class="ui padded grid">
    <back-button/>

    <div class="sixteen wide column">
      <div class="ui huge dividing header">
        {{ surveyTitle }}
      </div>

      <form
        class="ui big form"
        :id="formId"
        v-if="typeof(patient) !== 'undefined' ">
        <div class="field">
          <div class="fields">
            <div class="three wide field">
              <p style="margin-bottom: 0;">{{ $t('medgateId') }}</p>
              <h2 style="margin-top: 0;">
                {{ medgateId }}
              </h2>
              <p style="margin-bottom: 0;">{{ $t('name') }}</p>
              <h2 style="margin-top: 0;">
                {{ name }}
              </h2>
            </div>
          </div>
        </div>

        <qn-demographics/>

        <qn-midas/>

        <qn-pam/>

        <qn-end/>

        <br>

        <button
          class="ui button"
          @click.prevent="postOneAnswer"
          :class="{ disabled: loadingState}">
          <span v-if="loadingState === false">Submit</span>
          <span v-if="loadingState === true"><i class="ui spinner loading icon"/></span>
        </button>

        <div class="ui error message"/>
      </form>
    </div>
  </div>
</template>

<script>
import QnPam from './QnPam.vue'
import QnMidas from './QnMidas.vue'
import QnDemographics from './QnDemographics.vue'
import QnEnd from './QnEnd.vue'
import BackButton from '../menu/BackButton'

export default {
  props: {
    checkpoint: {
      required: true,
      type: String
    },
    patient: {
      required: true,
      type: Object
    }
  },
  components: {
    BackButton,
    QnPam,
    QnMidas,
    QnDemographics,
    QnEnd
  },
  data () {
    return {
      formId: 'form' + this._uid,
      medgateId: this.patient ? this.patient.medgateId : null,
      patientUserId: this.patient ? this.patient.mbUserId : null,
      name: this.patient ? this.patient.name : null,
      loadingState: false
    }
  },
  computed: {
    surveyTitle: function () {
      switch (this.checkpoint) {
        case 'dayminus30':
          return this.$t('assessments.daySurvey', { day: 0 })
        case 'day0':
          return this.$t('assessments.daySurvey', { day: 30 })
        case 'day30':
          return this.$t('assessments.daySurvey', { day: 60 })
        case 'day90':
          return this.$t('assessments.daySurvey', { day: 120 })
        case 'day180':
          return this.$t('assessments.daySurvey', { day: 210 })
        case 'day270':
          return this.$t('assessments.daySurvey', { day: 300 })
        default:
          return this.$t('assessments.doesNotExist')
      }
    }
  },
  methods: {
    postOneAnswer: function (event) {
      event.preventDefault()

      let formStatus = $('#' + this.formId).form('validate form')
      if (formStatus === true) {
        this.loadingState = true
        let requestUrl = process.env.VUE_APP_QB_ANSWER_URL
        this.$axios.post(requestUrl, this.constructDataObject())
          .then(
            response => {
              this.$router.push({ name: 'Assessments' })
            },
            error => {
              this.loadingState = false
              this.$rollbar.error('error in posting answer', error, this.constructDataObject())

              $('#' + this.formId).form('add errors', [this.$t('assessments.postingError')])
              window.scrollTo(0, document.body.scrollHeight) // scroll to bottom of page to display the error message
            }
          )
      } else {
        $('#' + this.formId).form('validate form')
        $('#' + this.formId).form('add errors', [this.$t('assessments.validationErrors.general')])
        window.scrollTo(0, document.body.scrollHeight) // scroll to bottom of page to display the error message
      }
    },
    constructDataObject: function () {
      let formResponse = {
        'form_id': this.checkpoint,
        'hidden': {
          'userid': this.patientUserId // TODO: this should be the userid. Check if this can be a number instead of a string. or use JSON Stringfy
        },
        'definition': {
          'fields': []
        },
        'answers': [

          // Demographics: 7 Questions
          {
            'field': {
              'id': 'demo-1',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('demo-1') !== null ? document.getElementById('demo-1').value : null
          },
          {
            'field': {
              'id': 'demo-2',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('demo-2') !== null ? document.getElementById('demo-2').value : null
            }
          },
          {
            'field': {
              'id': 'demo-3',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('demo-3') !== null ? document.getElementById('demo-3').value : null
            }
          },
          {
            'field': {
              'id': 'demo-4',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('demo-4') !== null ? document.getElementById('demo-4').value : null
            }
          },
          {
            'field': {
              'id': 'demo-5',
              'type': 'multiple_choice'
            },
            'type': 'choices',
            'choices': { // NOTE: Have to get value of multiple select dropdown with $('#demo-5').val()
              'labels': document.getElementById('demo-5') !== null ? $('#demo-5').val() : []
            }
          },
          {
            'field': {
              'id': 'demo-6',
              'type': 'multiple_choice'
            },
            'type': 'choices',
            'choices': {
              'labels': document.getElementById('demo-6') !== null ? $('#demo-6').val() : []
            }
          },
          {
            'field': {
              'id': 'demo-7',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('demo-7') !== null ? document.getElementById('demo-7').value : null
            }
          },

          // MIDAS: 7 Questions
          {
            'field': {
              'id': 'midas-1',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('midas-1') !== null ? document.getElementById('midas-1').value : null
          },
          {
            'field': {
              'id': 'midas-2',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('midas-2') !== null ? document.getElementById('midas-2').value : null
            }
          },
          {
            'field': {
              'id': 'midas-3',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('midas-3') !== null ? document.getElementById('midas-3').value : null
          },
          {
            'field': {
              'id': 'midas-4',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('midas-4') !== null ? document.getElementById('midas-4').value : null
          },
          {
            'field': {
              'id': 'midas-5',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('midas-5') !== null ? document.getElementById('midas-5').value : null
          },
          {
            'field': {
              'id': 'midas-6',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('midas-6') !== null ? document.getElementById('midas-6').value : null
          },
          {
            'field': {
              'id': 'midas-7',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('midas-7') !== null ? document.getElementById('midas-7').value : null
          },

          // PAM Questions (10 questions)
          {
            'field': {
              'id': 'pam-1',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-1') !== null ? document.getElementById('pam-1').value : null
            }
          },
          {
            'field': {
              'id': 'pam-2',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-2') !== null ? document.getElementById('pam-2').value : null
            }
          },
          {
            'field': {
              'id': 'pam-3',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-3') !== null ? document.getElementById('pam-3').value : null
            }
          },
          {
            'field': {
              'id': 'pam-4',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-4') !== null ? document.getElementById('pam-4').value : null
            }
          },
          {
            'field': {
              'id': 'pam-5',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-5') !== null ? document.getElementById('pam-5').value : null
            }
          },
          {
            'field': {
              'id': 'pam-6',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-6') !== null ? document.getElementById('pam-6').value : null
            }
          },
          {
            'field': {
              'id': 'pam-7',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-7') !== null ? document.getElementById('pam-7').value : null
            }
          },
          {
            'field': {
              'id': 'pam-8',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-8') !== null ? document.getElementById('pam-8').value : null
            }
          },
          {
            'field': {
              'id': 'pam-9',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-9') !== null ? document.getElementById('pam-9').value : null
            }
          },
          {
            'field': {
              'id': 'pam-10',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('pam-10') !== null ? document.getElementById('pam-10').value : null
            }
          },

          // End of Program: 12 Questions
          {
            'field': {
              'id': 'end-1',
              'type': 'number'
            },
            'type': 'number',
            'number': document.getElementById('end-1') !== null ? document.getElementById('end-1').value : null
          },
          {
            'field': {
              'id': 'end-2',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-2') !== null ? document.getElementById('end-2').value : null
            }
          },
          {
            'field': {
              'id': 'end-3',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-3') !== null ? document.getElementById('end-3').value : null
            }
          },
          {
            'field': {
              'id': 'end-4',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-4') !== null ? document.getElementById('end-4').value : null
            }
          },
          {
            'field': {
              'id': 'end-5',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-5') !== null ? document.getElementById('end-5').value : null
            }
          },
          {
            'field': {
              'id': 'end-6',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-6') !== null ? document.getElementById('end-6').value : null
            }
          },
          {
            'field': {
              'id': 'end-7',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-7') !== null ? document.getElementById('end-7').value : null
            }
          },
          {
            'field': {
              'id': 'end-8',
              'type': 'multiple_choice'
            },
            'type': 'choices',
            'choices': {
              'labels': document.getElementById('end-8') !== null ? $('#end-8').val() : []
            }
          },
          {
            'field': {
              'id': 'end-9',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-9') !== null ? document.getElementById('end-9').value : null
            }
          },
          {
            'field': {
              'id': 'end-10',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-10') !== null ? document.getElementById('end-10').value : null
            }
          },
          {
            'field': {
              'id': 'end-11',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-11') !== null ? document.getElementById('end-11').value : null
            }
          },
          {
            'field': {
              'id': 'end-12',
              'type': 'multiple_choice'
            },
            'type': 'choice',
            'choice': {
              'label': document.getElementById('end-12') !== null ? document.getElementById('end-12').value : null
            }
          }
        ]
      }
      return { 'form_response': formResponse }
    },
    initFormValidation: function () {
      $.fn.form.settings.rules.onlyNo = (value) => {
        if (value.includes(1) && value.length > 1) {
          return false
        } else {
          return true
        }
      }

      $('#' + this.formId).form({
        fields: {
          'demo-1': 'empty',
          'demo-2': 'empty',
          'demo-3': 'empty',
          'demo-4': 'empty',
          'demo-5': ['empty', 'onlyNo'],
          'demo-6': ['empty', 'onlyNo'],
          'demo-7': 'empty',

          'midas-1': ['integer[0..90]', 'empty'],
          'midas-2': 'empty',
          'midas-3': ['integer[0..90]', 'empty'],
          'midas-4': ['integer[0..90]', 'empty'],
          'midas-5': ['integer[0..90]', 'empty'],
          'midas-6': ['integer[0..90]', 'empty'],
          'midas-7': ['integer[0..90]', 'empty'],

          'pam-1': 'empty',
          'pam-2': 'empty',
          'pam-3': 'empty',
          'pam-4': 'empty',
          'pam-5': 'empty',
          'pam-6': 'empty',
          'pam-7': 'empty',
          'pam-8': 'empty',
          'pam-9': 'empty',
          'pam-10': 'empty',

          'end-1': ['integer', 'empty'],
          'end-2': 'empty',
          'end-3': 'empty',
          'end-4': 'empty',
          'end-5': 'empty',
          'end-6': 'empty',
          'end-7': 'empty',
          'end-8': 'empty',
          'end-9': 'empty',
          'end-10': 'empty',
          'end-11': 'empty',
          'end-12': 'empty'
        },
        inline: true,
        prompt: {
          empty: this.$t('assessments.validationErrors.empty'),
          integer: this.$t('assessments.validationErrors.integer'),
          onlyNo: this.$t('assessments.validationErrors.onlyNo')
        }
      })
    }
  },
  mounted () {
    $('.ui.dropdown').dropdown()

    this.initFormValidation()

    if (!this.patient) {
      if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
        this.$router.push({ name: 'Assessments' })
      }
    }
  }

}
</script>

<style>
  .german {
    color: mediumseagreen !important;
  }

</style>
